import {happyIcon , mindMapIcon , cameraIcon , lightningIcon , photoIcon , coinsIcon} from '../components/images/svg/icons'

export const lookingForFeatures = [
  {
    icon: happyIcon,
    title: 'AMBASSADOR_LOOKINGFOR_SELFEMPLOYED_TITLE',
    description: 'AMBASSADOR_LOOKINGFOR_SELFEMPLOYED_DESCRIPTION'
  },
  {
    icon: mindMapIcon,
    title: 'AMBASSADOR_LOOKINGFOR_JOURNEY_TITLE',
    description: 'AMBASSADOR_LOOKINGFOR_JOURNEY_DESCRIPTION'
  },
  {
    icon: cameraIcon,
    title: 'AMBASSADOR_LOOKINGFOR_STORY_TITLE',
    description: 'AMBASSADOR_LOOKINGFOR_STORY_DESCRIPTION'
  }
];

export const benefitsFeatures = [
  {
    icon: lightningIcon,
    title: 'AMBASSADOR_BENEFITS_EXPERTISE_TITLE',
    description: 'AMBASSADOR_BENEFITS_EXPERTISE_DESCRIPTION'
  },
  {
    icon: photoIcon,
    title: 'AMBASSADOR_BENEFITS_MEDIA_TITLE',
    description: 'AMBASSADOR_BENEFITS_MEDIA_DESCRIPTION'
  },
  {
    icon: coinsIcon,
    title: 'AMBASSADOR_BENEFITS_EARN_TITLE',
    description: 'AMBASSADOR_BENEFITS_EARN_DESCRIPTION'
  }
];

export const partners = [
  {
    titleKey: 'AMBASSADOR_PARTNER_TRADEDOUBLER_TITLE',
    descriptionKey: 'AMBASSADOR_PARTNER_TRADEDOUBLER_DESCRIPTION',
    link:"https://directory.tradedoubler.com/en/programs/344244-Invozio"
  },
  {
    titleKey: 'AMBASSADOR_PARTNER_METAPIC_TITLE',
    descriptionKey: 'AMBASSADOR_PARTNER_METAPIC_DESCRIPTION', // (use correct key here)
    link: 'https://app.metapic.com?join-campaign=7q8jf7tme28y7tmn',
  },
];
